<script lang="ts">
	import type { PageContent } from "$lib/def/seo/page";
	import type { PageServerData as SeoPSD } from "../../../../routes/(app)/delivery/[vertical=seoVertical]/$types";
	import type { PageServerData as PSD } from "../../../../routes/(app)/$types";

	import SeoBrandsLane from "$lib/ui/shared/seo/SeoBrandsLane.svelte";
	import SeoTagsLane from "$lib/ui/shared/seo/SeoTagsLane.svelte";
	import AppDownload from "./AppDownload.svelte";
	import SeoAreaSelector from "./SeoAreaSelector.svelte";
	import SeoBrandList from "./SeoBrandList.svelte";
	import SeoBusinessInfo from "./SeoBusinessInfo.svelte";
	import SeoFooter from "./SeoFooter.svelte";
	import SeoHeader from "./SeoHeader.svelte";
	import SeoImageSlider from "./SeoImageSlider.svelte";
  import SeoBusinessInfoItem from "$lib/ui/shared/seo/SeoBusinessInfoItem.svelte";
  import { selectAddress } from "$lib/ui/modals/AddressModal.svelte";
	import SeoExtraCopy from "$lib/ui/shared/seo/SeoExtraCopy.svelte";

	export let data: PSD | SeoPSD;
	export let content: PageContent | undefined;

</script>

<div class="full-width">
	
	{#if content}
		<SeoHeader image={content.image} title={content.title} subtitle={content.description} />
	{/if}
	
	<SeoBrandList brands={data.brands} title="Hungry? Choose from 12 000 of the best restaurants. " />
	
	<!-- Tags: Food -->
	<SeoTagsLane title="Popular food types" list={data.cuisines} />
	
	<!-- Brands -->
	<SeoBrandsLane title="Popular restaurants" list={data.brands} />
	
	<!-- Tags: Stores -->
	<SeoTagsLane title="Shop by department" list={data.departments} />
	
	<SeoBusinessInfo>
		<SeoBusinessInfoItem item={data.biFeatures[0]} cta={{text: 'Order now', action: selectAddress}} />
		<SeoBusinessInfoItem item={data.biFeatures[1]} cta={{text: 'Order now', action: selectAddress}} />
		<SeoBusinessInfoItem item={data.biFeatures[2]} cta={{text: 'Order now', action: selectAddress}} />
	</SeoBusinessInfo>
	
	<!-- App download -->
	{#if data.apps.main}
		<AppDownload main={data.apps.main} appstores={data.apps.stores} />
	{/if}
	
	<!-- corporate links -->
	<SeoBusinessInfo>
		<SeoBusinessInfoItem item={data.biCorpLinks[0]} cta={{text: 'Get started', action: '/about/become-a-partner'}} />
		<SeoBusinessInfoItem item={data.biCorpLinks[1]} cta={{text: 'Apply now', action: '/about/become-a-driver'}} />
		<SeoBusinessInfoItem item={data.biCorpLinks[2]} cta={{text: 'Apply now', action: '/about/careers'}} />
	</SeoBusinessInfo>
	
	<!-- Image slider -->
	<SeoImageSlider images={data.slides} />
	
	<!-- Area selector -->
	<SeoAreaSelector areas={data.parentAreas} />
	
	{#if 'extra' in data}
		<!-- Extra SEO Copy-->
		<SeoExtraCopy seoExtras={data.extra} />
	{/if}

	<!-- Footer area -->
	<SeoFooter appstores={data.apps.stores} socials={data.social} tallogo={data.tallogo}/>
</div>